<template>
	<div class="fuWu">
		<div class="liucheng">
			<div>
				<ul>
					<li @click="select(item, index)" v-for="(item, index) in list" :key="index" :class="{ active: activeNum === index }">{{ item.name }}</li>
				</ul>
				<div>
					<div v-if="activeNum === 1" id="container"></div>
					<div v-if="activeNum === 1" class="lianxi">
						<p>
							<span>地址：</span>
							长江大道315号创新大厦A座9-903室
						</p>
						<p>
							<span>电话：</span>
							0311-89929485
						</p>
						<p>
							<span>E-mail：</span>
							sfjd@bjzjtp.com
						</p>
					</div>
					<img v-else src="../../images/liucheng.png" />
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import axios from 'axios';
import '../assets/css/fuWu.less';
export default {
	name: 'index',
	data() {
		return {
			activeNum: 0,
			list: [{ name: '服务流程' }, { name: '联系我们' }]
		};
	},
	methods: {
	  select (item, index) {
	    this.activeNum = index
	    if (index === 1) {
	      setTimeout(() => {
	        var map = new BMap.Map("container");    
	        var point = new BMap.Point(114.662576,38.044547);    
	        map.centerAndZoom(point, 15); 
	        var opts = {anchor: BMAP_ANCHOR_TOP_RIGHT, type: BMAP_NAVIGATION_CONTROL_LARGE} 
	        map.addControl(new BMap.NavigationControl(opts));
	        var marker = new BMap.Marker(point);
	        map.addOverlay(marker);  
	        map.enableScrollWheelZoom(true);
	        var information = {    
	          width : 200,     // 信息窗口宽度    
	          height: 100,     // 信息窗口高度 
	          offset: {height: -20, width: 0}
	        }
	        var html = `<div class="baidu-map">
	          <p>
	            中经天平司法鉴定中心
	          </p>
	          <p>
	            长江大道315号创新大厦A座9-903室
	          </p>
	          <p>
	            联系电话：0311-89929485
	          </p>
	        </div>
	        `
	        var infoWindow = new BMap.InfoWindow(html, information);  // 创建信息窗口对象    
	        map.openInfoWindow(infoWindow, map.getCenter());
	        marker.addEventListener("click", function() {
	          var information = {    
	            width : 200,     // 信息窗口宽度    
	            height: 90,     // 信息窗口高度 
	          }
	          var infoWindow = new BMap.InfoWindow(html, information);
	          // 调用了marker对象的openInfoWindow方法
	          this.openInfoWindow(infoWindow); 
	        });
	      }, 200)
	    }
	  }
	},
	components: {},
	computed: {},
	watch: {},
	created() {}
};
</script>

<style>
	
</style>
